import React from 'react';
import { graphql } from 'gatsby';
import { normalizeBlockContentNodes } from '@blocks-helpers';
import BasePage from '@elegantstack/solid-ui-blocks/src/BasePage';
import IndustryBlock from '@solid-ui-blocks/IndustryBlock/Block04';
import { css, Heading } from 'theme-ui';
import HowItWorks from '@solid-ui-blocks/FeaturesWithPhoto/Block012';
import GetStartedWithPhoto from '@solid-ui-blocks/GetStartedWithPhoto/GetStartedWithPhoto';
import Divider from '@solid-ui-components/Divider/Divider';
import BenefitsPercentage from '@solid-ui-blocks/BenefitsPercentage/BenefitsPercentage';
import Apps from '@solid-ui-blocks/Apps/AppsWithoutIcons/Apps';
import HelpfulResources from '@solid-ui-blocks/HelpfulResources/HelpfulResources';
import Faq from '@solid-ui-blocks/Faq/Block03';
import ClickableReview from '@solid-ui-blocks/Review/ClickableReview/ClickableReview';
import GetStarted from '@solid-ui-blocks/Features/Block07';
import LayoutWrapper from '@solid-ui-layout/LayoutWrapper/LayoutWrapper';

const styles = {
  ellipse: {
    position: 'absolute',
    left: 0,
    top: '275px',
    width: '100%',
    height: ['430px', '460px', '450px', '370px'],
    background: 'linear-gradient(0deg, #F0F9FF 13%, #FFFFFF 100%)',
    clipPath: ['ellipse(100% 100% at top)', 'ellipse(160% 100% at top)', 'ellipse(100% 100% at top)', 'ellipse(100% 100% at top)'],
    zIndex: '-10',
  },
  blockHeading: {
    fontSize: '36px',
    fontWeight: 600,
    lineHeight: '54px',
    color: '#101828',
    pb: '40px',
    pt: '60px',
    textAlign: 'center',
  },
  presentationBlock: {
    backgroundColor: '#F0F9FF',
    borderRadius: '12px',
    padding: '24px',
    textAlign: 'center',
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto',
    fontFamily: '"Inter", sans-serif',
  },
  presentationTitle: {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: '32px',
    marginBottom: '12px',
    color: '#101828',
    fontFamily: '"Inter", sans-serif',
  },
  presentationText: {
    fontSize: '18px',
    lineHeight: '26px',
    marginBottom: '16px',
    color: '#475467',
    opacity: 0.9,
    fontFamily: '"Inter", sans-serif',
  },
  downloadButton: {
    padding: '12px 24px',
    fontSize: '16px',
    backgroundColor: '#21A7E5',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    fontWeight: 500,
    fontFamily: '"Inter", sans-serif',
    height: '48px',
    '&:hover': {
      backgroundColor: '#1A8CC2',
    }
  }
};

const Hospitality = (props) => {
  const {
    data: { allBlockContent },
    location: { pathname },
  } = props;
  const content = normalizeBlockContentNodes(allBlockContent?.nodes);

  return (
    <BasePage
      keywords={'hotel property management software, hospitality management system, track hospitality software, software for hospitality industry, hotel management app, hospitality inventory management software, cloud hotel management system'.split(
        ', '
      )}
      description={
        'Cloud hospitality software for efficient hotel management-scheduling, task management, checklists,and inventory control with. Free management app for small hotels.'
      }
      title='Hotel Task Management Software'
      pathname={pathname}
      {...props}
    >
      <div css={css(styles.ellipse)}></div>
      <IndustryBlock content={content} />
      <HowItWorks content={content['how-it-works']} />
      <Divider space={7} />
      <GetStartedWithPhoto content={content['get-started-with-photo']} />
      <Divider space={7} />
      <BenefitsPercentage content={content['benefits-data']} />
      <Divider space={7} />
      <ClickableReview content={content['review']} />
      <LayoutWrapper>
        <Heading as="div" sx={styles.blockHeading}>Streamline Management with Hotel Business Software</Heading>
      </LayoutWrapper>
      <Apps content={content['apps']} />
      <Divider space={7} />
      <Divider space={7} />
      <Faq content={content['faq']} />
      <Divider/>
      {/* Блок для скачивания презентации */}
      <div css={css(styles.presentationBlock)}>
        <h3 css={css(styles.presentationTitle)}>
          Download Our Hospitality Presentation!
        </h3>
        <p css={css(styles.presentationText)}>
          Learn how TARGPatrol can streamline your hospitality operations and improve efficiency.
        </p>
        <a 
          href="/TARGPatrol_HoReCa_EN.pdf" // Путь к файлу из static/
          download="TARGPatrol_HoReCa_EN.pdf" // Имя файла при скачивании
          onClick={() => console.log('Attempting to download:', '/TARGPatrol_HoReCa_EN.pdf')}
        >
          <button css={css(styles.downloadButton)}>
            Download Now
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </a>
      </div>
      <Divider space={7} />
      <HelpfulResources />
      <Divider space={7} />
      <Divider space={7} />
      <LayoutWrapper>
        <GetStarted content={content['get-started']} />
      </LayoutWrapper>
      <Divider space={7} />
    </BasePage>
  );
};

export const query = graphql`
  query hospitalityTargPatrolEnBlockContent {
    allBlockContent(filter: { page: { in: ["targpatrol-en/hospitality", "shared"] } }) {
      nodes {
        ...BlockContent
      }
    }
  }
`;

export default Hospitality;